import { render, staticRenderFns } from "./profession.vue?vue&type=template&id=40f790f2&scoped=true"
import script from "./profession.vue?vue&type=script&lang=js"
export * from "./profession.vue?vue&type=script&lang=js"
import style0 from "./profession.vue?vue&type=style&index=0&id=40f790f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f790f2",
  null
  
)

export default component.exports